const deepmerge = require('deepmerge')
const mustache = require('mustache')
const path = require('path-browserify')

const MOUNT_DATA_DEFAULT = {
  "build": {
    "root": "build"
  }
}
function GetArgs () {
  const args = require('minimist')(process.argv.slice(2))
  if (typeof args['mount'] !== 'string') {
    if (args[`_`] && args[`_`].length === 1) {
      args['mount'] = args[`_`][0]
    } else if (process.env.REACT_APP_MOUNT_KEY) {
      args['mount'] = process.env.REACT_APP_MOUNT_KEY
    }
  }
  return args
}

function GetEnvConfig (mountKey, mount, additional = {}) {
  return {
    REACT_APP_MOUNT_KEY: mountKey,
    REACT_APP_SITE_TITLE: mount.pageTitle.rendered,
    REACT_APP_LANG_ATTR: mount.options.lang_attr,
    ...additional
  }
}

function GetMountFilePath () {
  const args = GetArgs()
  return (typeof args['mountfile'] === 'string') ? (path.resolve(args['mountfile'])) : (path.resolve('src/mounts.json'))
}

function GetMount (MOUNT_DATA, MOUNT_KEY, withBuild = false) {
  const defaultMount = deepmerge(MOUNT_DATA_DEFAULT, MOUNT_DATA.default)
  const mount = deepmerge(defaultMount, MOUNT_DATA.mounts[MOUNT_KEY])
  if (!mount.pageTitle) { mount.pageTitle = {} }
  mount.pageTitle.rendered = GetPageTitle(mount)
  if (!withBuild) {
    delete mount.build
  }
  return mount
}

function GetMountWithBuild (MOUNT_DATA, MOUNT_KEY) {
  return GetMount(MOUNT_DATA, MOUNT_KEY, true)
}

function GetAllMounts (MOUNT_DATA) {
  return Object.keys(MOUNT_DATA.mounts).reduce((acc, key) => {
    acc[key] = GetMount(MOUNT_DATA, key)
    acc[key].mountKey = key
    return acc
  }, {})
}

function GetPageTitle (mount) {
  const versionSpecificPageTitle = mount?.options?.pageTitle?.template
  const defaultPageTitle = mount?.pageTitle?.template
  
  if (versionSpecificPageTitle || defaultPageTitle)
    return mustache.render(versionSpecificPageTitle || defaultPageTitle, mount)
  return 'PAGE_TITLE_NOT_SET'
}

module.exports = {
  GetArgs: GetArgs,
  GetMountFilePath: GetMountFilePath,
  GetMount: GetMount,
  GetAllMounts: GetAllMounts,
  GetMountWithBuild: GetMountWithBuild,
  GetEnvConfig: GetEnvConfig,
  PrefixColors: [
    'blue', 'magenta', 'cyan'
  ]
}
